import Actions from '../../odata/actions';

const actions = new Actions('mfcCode', 'mfcCodes');

export default actions;
